import ITag from 'models/Common/ITag'

export interface TagsProps {
  tags: ITag[] | null
  isAr: boolean
}

export const useTags = (props: TagsProps) => {
  return {
    ...props,
  }
}
